import React, { useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import { useSelfServeSignup } from 'api/useSelfServeSignup';
import { EToasterStatus, showToast } from 'utils/showToast';

import Button from 'components/Button/Button';
import Typography from 'components/Typography/Typography';

import AuthenticationLayout from './elements/AuthenticationLayout';

const ConfirmationPage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const { resendConfirmationEmail } = useSelfServeSignup();
  const [isLoading, setIsLoading] = useState(false);

  const handleResend = async () => {
    if (!email) {
      showToast({
        message: 'No email found.',
        status: EToasterStatus.ERROR
      });
      return;
    }
    setIsLoading(true);
    resendConfirmationEmail.mutate(
      { email },
      {
        onSuccess: () => {
          showToast({
            message: 'Confirmation email sent!',
            status: EToasterStatus.SUCCESS
          });
        },
        onError: (error) => {
          showToast({
            message: 'Failed to resend confirmation email.',
            status: EToasterStatus.ERROR,
            description:
              ((error as any)?.response?.data as { [key: string]: any })
                ?.message ?? 'Unknown error occurred'
          });
        },
        onSettled: () => setIsLoading(false)
      }
    );
  };

  return (
    <AuthenticationLayout
      main={
        <div className="text-center">
          <Typography tag="h4">Confirm your email address</Typography>
          <Typography className="text-p-s text-zinc-500 mt-2">
            Please check your email for a confirmation link. Didn’t receive the
            email? We’ll send you another.
          </Typography>
          <Button isLoading={isLoading} onClick={handleResend} className="mt-5">
            Resend Confirmation Email
          </Button>
        </div>
      }
      footer={
        <Typography className="text-p-s text-zinc-500 text-center">
          <div>
            Need help?{' '}
            <a
              href="mailto:support@appcharge-b2b.zendesk.com"
              className="underline font-bold"
            >
              Contact support
            </a>
          </div>
        </Typography>
      }
    />
  );
};

export default ConfirmationPage;
